import { arrayOf, elementType, func, number } from 'prop-types';
import React from 'react';

import ChangeRequestComment from '../../change-requests/ChangeRequestComment.container';
import {
  campaignShape,
  changeRequestShape,
  commentShape,
  userShape,
} from '../../prop-types';
import CommentEditor from '../CommentEditor.container';
import Replies from '../Replies.container';
import CommentBody from './CommentBody';
import CommentHeader from './CommentHeader';

class Comment extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: false,
      isReplying: false,
    };

    this.handleEdit = this.handleEdit.bind(this);
    this.handleReply = this.handleReply.bind(this);
    this.handleEditorCancel = this.handleEditorCancel.bind(this);
    this.handleEditorClick = this.handleEditorClick.bind(this);
  }

  handleEdit() {
    this.setState({ isEditing: true });
  }

  handleReply() {
    this.setState({ isReplying: true });
  }

  handleEditorCancel() {
    this.setState({ isEditing: false, isReplying: false });
  }

  handleEditorClick(changedComment) {
    return this.props
      .onEdit(this.props.model.id, changedComment)
      .then(this.handleEditorCancel);
  }

  renderComment() {
    const { model, sender, changeRequest } = this.props;

    const replyFormAlreadyAvailable =
      this.state.isReplying || changeRequest || model.replies.length > 0;

    return (
      <div className="border p-2 rounded">
        <CommentHeader
          model={model}
          sender={sender}
          withReplyToggle={
            !replyFormAlreadyAvailable && !model.parentId // Allow only one level of nesting
          }
          onEdit={this.handleEdit}
          onReply={this.handleReply}
        />
        <CommentBody model={model} />
      </div>
    );
  }

  renderEditor() {
    const { model, preferableMentions } = this.props;

    return (
      <CommentEditor
        default={model}
        onClick={this.handleEditorClick}
        onCancel={this.handleEditorCancel}
        preferableMentions={preferableMentions}
      />
    );
  }

  renderReplies() {
    const { model, changeRequest, Component, preferableMentions } = this.props;
    const withReplyForm = !!(
      this.state.isReplying ||
      changeRequest ||
      model.replies.length > 0
    );
    return (
      <Replies
        withReplyForm={withReplyForm}
        replies={model.replies}
        parentId={model.id}
        Component={Component}
        preferableMentions={preferableMentions}
      />
    );
  }

  renderChangeRequest() {
    const { changeRequest, model, sender, campaign } = this.props;
    return (
      <ChangeRequestComment
        comment={model}
        changeRequest={changeRequest}
        sender={sender}
        campaign={campaign}
      />
    );
  }

  renderMain() {
    if (this.props.changeRequest) {
      return this.renderChangeRequest();
    }

    if (this.state.isEditing) {
      return this.renderEditor();
    }

    return this.renderComment();
  }

  render() {
    return (
      <div className="mt-2">
        {this.renderMain()}
        {this.renderReplies()}
      </div>
    );
  }
}

Comment.propTypes = {
  model: commentShape.isRequired,
  onEdit: func.isRequired,
  sender: userShape.isRequired,
  changeRequest: changeRequestShape,
  Component: elementType.isRequired,
  preferableMentions: arrayOf(number),
  campaign: campaignShape.isRequired,
};

Comment.defaultProps = {
  changeRequest: undefined,
  preferableMentions: [],
};

export default Comment;
